import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=cf998c88&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"
import style0 from "./Loading.vue?vue&type=style&index=0&id=cf998c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf998c88",
  null
  
)

export default component.exports